// extracted by mini-css-extract-plugin
module.exports = {"container":"topic-enrollment-stats_container__7EVxe","text":"topic-enrollment-stats_text__nTsdl"};